import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminScbKommuner = lazy(() => import("@/pages/admin/AdminScbKommuner"));

export const Route = createFileRoute("/admin/statistik/scb_/kommuner")({
  component: () => <AdminScbKommuner />,
});
